
import moment from 'moment'
import { CreateUrl, CallPostAPI } from 'Utils/ApiHelper.js';
import {Readings  } from './GraphUtilityFunctions'
import { GraphTemplate } from '../../models/GraphTemplateModel'
import { flowConverter,  flowRateUnits } from '../../Utils/UnitConverters'
interface IntervalAdjustments {
    channel: string
    numberOfReadingsToAvg: number
    serial: number
    longestInterval: number

}

interface LogInterval {
    channelAInterval: number | null
    channelBInterval: number | null
    channelCInterval: number | null
    channelDInterval: number | null
    channelEInterval: number | null
    id: number
    intervalHasChanged: boolean
    serialNumber: number
}

export interface CombinedFlowValueAxis {
    A: { min: number | null, max: number | null }
    B: { min: number | null, max: number | null }
}


export interface CombinedFlowUnits {
    A: string
    B: string
}

export const getLoggerIntervals = (
    loggersIds: number[],
    startDate: Date,
    endDate: Date,
    setAllowCombinedFlow: (allow: boolean) => void,
    graphData: Readings[],
    setGraphData: (data: Readings[]) => void,
    unitsAndValues: GraphTemplate[],
    setCombinedFlowUnits: (data: CombinedFlowUnits) => void,
    setCombinedFlowValueAxis: (data: CombinedFlowValueAxis) => void
):void =>
{

    const loggerIntervalAdjustments: IntervalAdjustments[]= []
    if (loggersIds.length > 1) {
        const requestParamsInterval = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                startDate: moment(startDate).format("YYYY-MM-DD HH:mm:ss"),
                endDate: moment(endDate).format("YYYY-MM-DD HH:mm:ss"),
                loggers: loggersIds
            })
        }



        CallPostAPI(CreateUrl(`/api/aquaguard/getlogginginterval`), requestParamsInterval)
            .then(response => {
                return response.json()
            })
            .then((logInts: LogInterval[]) => {
                type HighestInts = { A: number, B: number, C: number, D: number, E: number }
                const highestIntervals: HighestInts = { A: 0, B: 0, C: 0, D: 0, E: 0 }
                if (logInts.map(int => int.channelAInterval).includes(600) || logInts.map(int => int.intervalHasChanged).includes(true)) {
                    // has 10 minute logging adn cant display combined flow rate
                    setAllowCombinedFlow(false)
                }
                if (logInts.map(int => int.channelBInterval).includes(600) || logInts.map(int => int.intervalHasChanged).includes(true)) {
                    // has 10 minute logging adn cant display combined flow rate
                    setAllowCombinedFlow(false)
                }
                logInts.forEach(int => {
                    if (int.channelAInterval !== 0 && int.channelAInterval !== null) {
                        if (int.channelAInterval > highestIntervals.A) {
                            highestIntervals.A = int.channelAInterval
                        }
                    }
                    if (int.channelBInterval !== 0 && int.channelBInterval !== null) {
                        if (int.channelBInterval > highestIntervals.B) {
                            highestIntervals.B = int.channelBInterval
                        }
                    }
                })
                logInts.forEach(int => {
                    if (int.channelAInterval && (int.channelAInterval !== highestIntervals.A)) {
                        if (highestIntervals.A !== 0) {
                            loggerIntervalAdjustments.push({ serial: int.serialNumber, channel: 'A', longestInterval: highestIntervals.A, numberOfReadingsToAvg: highestIntervals.A / int.channelAInterval })
                        }
                    }
                    if (int.channelBInterval && (int.channelBInterval !== highestIntervals.B)) {
                        if (highestIntervals.B !== 0) {
                            loggerIntervalAdjustments.push({ serial: int.serialNumber, channel: 'B', longestInterval: highestIntervals.B, numberOfReadingsToAvg: highestIntervals.B / int.channelBInterval })
                        }
                    }
                })

                setGraphData(addCombinedToGraphData(loggerIntervalAdjustments, graphData, unitsAndValues, setCombinedFlowUnits, setCombinedFlowValueAxis))
            })

    }
    
}


const addCombinedToGraphData = (
    loggerIntervalAdjustments: IntervalAdjustments[],
    graphData: Readings[],
    unitsAndValues: GraphTemplate[],
    setCombinedFlowUnits: (data: CombinedFlowUnits) =>void,
    setCombinedFlowValueAxis: (data: CombinedFlowValueAxis) => void
): unknown => {
    const valueAxis: CombinedFlowValueAxis = {
        A: { min: Number.MAX_VALUE, max: Number.NEGATIVE_INFINITY },
        B: { min: Number.MAX_VALUE, max: Number.NEGATIVE_INFINITY }
    } 
    let longestIntervalA = 0
    let longestIntervalB = 0
    const flowAUnitCount = [0, 0, 0, 0, 0, 0]
    const flowBUnitCount = [0, 0, 0, 0, 0, 0]
    const graphDataTemp = [...graphData]
    interface CombinedDataA {
        combinedFlowA: number | null
        date: Date
    }
    interface CombinedDataB {
        combinedFlowB: number | null
        date: Date
    }
    const newCombinedDataA: CombinedDataA[] = []
    const newCombinedDataB: CombinedDataB[] = []
    loggerIntervalAdjustments.forEach(log => {
        if (log.channel === 'A') {
            longestIntervalA = log.longestInterval
        }
        if (log.channel === 'B') {
            longestIntervalB = log.longestInterval
        }
    })
    unitsAndValues.forEach(u => {
        const sett = u.graphSettings
        flowRateUnits.forEach((unit, idx) => {
            if (unit.value === sett.flowAUnit) {
                flowAUnitCount[idx]++
            }
        })
        flowRateUnits.forEach((unit, idx) => {
            if (unit.value === sett.flowBUnit) {
                flowBUnitCount[idx]++
            }
        })
    })
    const flowUnitA = flowRateUnits[flowAUnitCount.indexOf(Math.max(...flowAUnitCount))].value
    const flowUnitB = flowRateUnits[flowBUnitCount.indexOf(Math.max(...flowBUnitCount))].value
    graphDataTemp.forEach((reading: Readings) => {
        if (reading.ChannelLetter === 'A') {
            const addToArray = flowConverter(flowUnitA, unitsAndValues.find(u => u.serial === parseInt(reading.serial))?.graphSettings.flowAUnit) ? reading[`${reading.serial}flowRateA`] * flowConverter(flowUnitA, unitsAndValues.find(u => u.serial === parseInt(reading.serial))?.graphSettings.flowAUnit) : null
            if (newCombinedDataA.length > 0 && moment(reading.date).isSame(moment(newCombinedDataA[newCombinedDataA.length - 1].date))) {
                newCombinedDataA[newCombinedDataA.length - 1].combinedFlowA += reading[`${reading.serial}flowRateA`]
            } else {
                if (newCombinedDataA.length === 0 && addToArray) {
                    newCombinedDataA.push(
                        {
                            combinedFlowA: addToArray,
                            date: reading.date
                        }
                    )
                }
                
                else if (((moment(reading.date).diff(moment(newCombinedDataA[newCombinedDataA.length - 1].date), 'seconds') === longestIntervalA) || longestIntervalA === 0) && addToArray) {
                    console.log(addToArray, newCombinedDataA)
                    newCombinedDataA.push(
                        {
                            combinedFlowA: addToArray,
                            date: reading.date
                        }
                    )
                }
            }
            
            if (addToArray && valueAxis.A.min && addToArray < valueAxis.A.min) {
                valueAxis.A.min = addToArray
            }
            if (addToArray && valueAxis.A.max && addToArray > valueAxis.A.max) {
                valueAxis.A.max = addToArray
            }
        }
        //console.log(valueAxis)

        if (reading.ChannelLetter === 'B') {
            const addToArray = flowConverter(flowUnitB, unitsAndValues.find(u => u.serial === parseInt(reading.serial))?.graphSettings.flowBUnit) ? reading[`${reading.serial}flowRateB`] * flowConverter(flowUnitB, unitsAndValues.find(u => u.serial === parseInt(reading.serial))?.graphSettings.flowBUnit) : null
            if (newCombinedDataB.length > 0 && moment(reading.date).isSame(moment(newCombinedDataB[newCombinedDataB.length - 1].date))) {
                newCombinedDataB[newCombinedDataB.length - 1].combinedFlowB += reading[`${reading.serial}flowRateB`]
            } else {
                if (newCombinedDataB.length === 0) {
                    newCombinedDataB.push(
                        {
                            combinedFlowB: addToArray,
                            date: reading.date
                        }
                    )
                }
                else if ((moment(reading.date).diff(moment(newCombinedDataB[newCombinedDataB.length - 1].date), 'seconds') === longestIntervalB || longestIntervalB === 0) && addToArray) {
                    newCombinedDataB.push(
                        {
                            combinedFlowB: addToArray,
                            date: reading.date
                        }
                    )
                }

            }
        }
        
    })
    setCombinedFlowValueAxis(valueAxis)
    setCombinedFlowUnits({ A: flowUnitA, B: flowUnitB })
    console.log(newCombinedDataA)
    const mergedData = [...newCombinedDataA, ...newCombinedDataB, ...graphDataTemp].sort((a, b) =>
        new Date(a.date).getTime() - new Date(b.date).getTime()
    )
    return mergedData
}